import { Injectable, signal } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class FarSharedService {
  farSelectedSectionNotificationSubject = new ReplaySubject<number>();
  isFarSidenavOpen = signal(false); //this is used for Mobile I think
  isFarSidenavOpenDesktop = signal(true); //this is used for Desktop I think
}
